import client from './client'

export const whoAmI = () => client.get('users/whoami?include=providers')

export const triggerPasswordResetEmail = (email: string) => {
  return client.post(
    'password',
    {
      email,
      redirect_uri: process.env.REACT_APP_REDIRECT_URI,
      client_id: process.env.REACT_APP_CLIENT_ID
    },
    {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      }
    }
  )
}

export const signInWithPassword = (email: string, password: string) => {
  return client.post(
    'sign_in/password',
    {
      login_type: 'password',
      session: { email, password },
      redirect_uri: process.env.REACT_APP_REDIRECT_URI,
      client_id: process.env.REACT_APP_CLIENT_ID,
      state: (Math.random() + 1).toString(36).substring(7)
    },
    {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      }
    }
  )
}
